// extracted by mini-css-extract-plugin
export default {"Input":"input_Input__Sy5u2"};